/**
 * This file defines app-wide constants. Please make everything that makes sense
 * (e.g. might differ between local, staging, prod) available as environment variable.
 * The default value should be the one used for local development.
 */
// NOTE: The name always has to start with REACT_APP_ or is ignored by react
const settings = {
  apiUrl: process.env.REACT_APP_API_URL,
  wsUrl: process.env.REACT_APP_WS_URL,
  /** Product name. Only used for branding / feature switches inside the frontend, never sent to the backend. */
  product: process.env.REACT_APP_PRODUCT,
  /** Tenant uuid (Django admin > Tenant). Sent on login, social login, registration and password reset. */
  tenantId: process.env.REACT_APP_TENANT_ID,
  /** SimulationType uuid (Django admin > Simulation type). Sent as X-Context-Id header on every request. */
  productId: process.env.REACT_APP_PRODUCT_ID,
  jsonSchemaVersion: process.env.REACT_APP_JSON_SCHEMA_VERSION,
};

export default settings;
